module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_housewarming-8ac3781fb99e1cc40479858cf6f21ac7.jpg";